export default __webpack_public_path__ + "static/media/(98).b15ce32f.jpg";